module.exports = __webpack_public_path__ + "assets/images/project/menu/cambodia-thumb.jpg?v=c9ace813";